<div class="mat-form-field upload-photo" style="overflow: hidden;">
  <div class="file-upload" [ngClass]="{'error': control.touched&&control.hasError('required')  }"
    *ngIf="!control.value">
    <label for="doc">{{label? label : 'Upload ' + type | titlecase}}
      <app-required *ngIf="control.hasError('required')"></app-required>
    </label>
    <input [attr.disabled]="isEditable?null:true" type="file" [accept]="accept" [formControl]="fileControl"
      (change)="onSelectedFile($event)" #file />
  </div>
  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <div class="red" *ngIf="control.touched && control.hasError('required')">
      {{label}} is less than {{fileSize}}MB<strong> required</strong>.
    </div>
  </ng-container>

  <div class="hint pl-2 p-1" *ngIf="hint">{{hint}}</div>
  <div class="downlaodlnk form-control" *ngIf="control.value && view==undefined">
    <a (click)="downloadFile()" target="_blank">
      <i class="fa fa-download"></i> View / Download File</a>
    <button *ngIf="isEditable && !hideClose" (click)="removeFile()" class="btn btn-danger" type="button"
      matTooltip="Remove this File" matTooltipPosition="below" style="padding: 7px;">
      <mat-icon style="transform: scale(0.7)">close</mat-icon>
    </button>
  </div>
  <div class="downlaodlnk form-control" *ngIf="control.value && view != undefined" style="text-align: center;">
    <a *ngIf="mediaType!='Image'" (click)="downloadFileView()">
      <i class="fa fa-download" style="padding-top: 10px"></i> View / Download File</a>
    <a *ngIf="mediaType=='Image'" (click)="downloadFileView()">
      <img [src]="control.value?control.value.url:control.value"
        style="width: 100%;height: 150px;border: 1px solid #000;"><br>
      <i class="fa fa-download" style="padding-top: 10px"></i> &nbsp;{{ control.value ? (control.value?.date | date:
      'dd/MM/yyyy') : 'View / Download File' }}
    </a>
    <button *ngIf="isEditable && hideClose" (click)="removeFile()" class="btn btn-danger" type="button"
      matTooltip="Remove this File" matTooltipPosition="below" style="padding: 7px;">
      <mat-icon style="transform: scale(0.7)">close</mat-icon>
    </button>
  </div>

</div>